import React, { useContext, useMemo, useReducer } from 'react'

import { Box, IconButton, Tooltip } from '@mui/material'
import { api } from '../../../services/api';
import toast from 'react-hot-toast'
import { getSession } from '../../../contexts/auth';
import { lockedReducer } from '../../Utils/reducers';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import { externalComponent } from '../../AppRoutes';
import EditAReceberModal from './edit';
import Table, { TableHook } from '../../Table';
import dayjs from 'dayjs';
import { maskedTable } from '../../Utils/MaskedInput';
import Quitate from './quitate';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { ResponsiveActionBox } from '../../Table/mobileTable';

const url = '/toreceive/'

const submitDelete = async (data, setState, getData, setLoader) => {
    setLoader(true)
    const res = await api.delete(`${url}${data.id}/`)
    setLoader(false)
    if (res.status === 204) {
        toast.success('Deletado com sucesso')
        setState({ deleteRow: false })
        getData()
        return
    }
    console.error('Falha ao deletar')

}

const columns = (setState, permissions) => {
    return [
        { field: 'numbermod', headerName: 'N° Documento', flex: 1, filterType: 'string' },
        { field: 'client_name', headerName: 'Cliente', flex: 1, filterType: 'string' },
        { field: 'revenue_name', headerName: 'Despesa', flex: 1, filterType: 'string' },
        {
            field: 'emission', headerName: 'Emissão', flex: 1, filterType: 'daterangeless',
            valueGetter: ({ value }) => dayjs(value).format('DD/MM/YYYY')
        },
        {
            field: 'duedate', headerName: 'Vencimento', flex: 1, filterType: 'daterangeless',
            valueGetter: ({ value }) => dayjs(value).format('DD/MM/YYYY')
        },
        {
            field: 'value', headerName: 'Valor', flex: 1, filterType: 'number',
            valueGetter: ({ value }) => {
                return maskedTable['value'](value)
            }
        },
        {
            field: 'paid', headerName: 'Recebido', flex: 1, filterType: 'number',
            valueGetter: ({ value }) => {
                return value ? maskedTable['value'](value) : ''
            }
        },
        {
            field: 'quitated', headerName: 'Quitado', flex: 1, filterType: 'choices', choices: { '1': 'Sim', '0': 'Não' }, hide: true
        },
        {
            field: 'actions', headerName: 'Ações', filterable: false, flex: 1,
            renderCell: (props) => {
                return (
                    <ResponsiveActionBox >
                        {(permissions.change_toreceive && !props.row.quitated) && <Tooltip title='Quitar documento'><IconButton onClick={() => { setState({ quitate: props.row }) }}><TaskAltIcon /></IconButton></Tooltip>}
                        {(permissions.change_toreceive && !props.row.quitated) && <Tooltip title='Editar documento'><IconButton onClick={() => { setState({ editRow: props.row }) }}><EditIcon /></IconButton></Tooltip>}
                        {(permissions.view_toreceive && props.row.quitated) && <Tooltip title='Verificar documento'><IconButton onClick={() => { setState({ quitate: { ...props.row, view_only: true } }) }}><AssignmentIcon /></IconButton></Tooltip>}
                        {permissions.delete_toreceive && <Tooltip title='Excluir documento'><IconButton onClick={() => { setState({ deleteRow: props.row }) }}><DeleteIcon /></IconButton></Tooltip>}
                    </ResponsiveActionBox>
                )
            }
        }
    ]
}

const AReceber = () => {

    const { setLoader } = useContext(externalComponent)

    const user = getSession()

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        editRow: null,
        deleteRow: null,
        quitate: null
    })

    const [table, reloadData] = TableHook()

    return (
        <>
            {state.deleteRow &&
                <ConfirmationDialog
                    content={`Deseja excluir a conta a receber ${state.deleteRow.identifier}?`}
                    handleClose={() => setState({ deleteRow: null })}
                    onConfirm={() => submitDelete(state.deleteRow, setState, reloadData, setLoader)}
                />
            }
            {state.editRow &&
                <EditAReceberModal
                    data={state.editRow}
                    handleClose={() => setState({ editRow: null })}
                    reloadData={reloadData}
                />
            }
            {state.quitate &&
                <Quitate
                    data={state.quitate}
                    handleClose={() => setState({ quitate: null })}
                    reloadData={reloadData}
                />
            }
            <Box className='information-table'>

                <Box className='user-table'>
                    <Table
                        rows={state.rows}
                        columns={useMemo(() => columns(setState, user.permissions), [user.permissions])}
                        pagination
                        density='compact'
                        slots={{
                            addComponent: () => user.permissions.add_toreceive ? setState({ editRow: {} }) : null,
                            filterComponent: true,
                            columnComponent: true
                        }}
                        toolbar
                        getRowClassName={(params) => `financeirorow--${params.row.quitated}`}
                        getURL={url}
                        updateRows={(rows) => setState({ 'rows': rows })}
                        innerRef={table}
                        mobile={true}
                        mobileProps={
                            {
                                title: ['numbermod'],
                                secondary: [['duedate'], ['value']],
                            }
                        }
                    />
                </Box>
            </Box>
        </>
    )
}

export default AReceber